import React from 'react';
import Footer from '../../components/Footer';
import SubFooter from '../../components/SubFooter';
import Img from "../../assets/maya.jpg";
import President_img from "../../assets/aboutus/president.png";
import HighestImg from "../../assets/courses/highest.gif";
import AvgImg from "../../assets/courses/avg.png";
import YearImg from "../../assets/courses/year.gif";
const stats = [
    { id: 1, name: 'Highest Package', value: '43.5 Lakh', image: HighestImg },
    { id: 2, name: 'Average Package', value: '5.48 Lakh', image: AvgImg },
    { id: 3, name: 'Years of Legacy', value: '14', image: YearImg },
];

const Presidents_msg = () => {
    return (
        <div className="w-full relative bg-gradient-to-b from-white to-gray-50">
            <h2 className="text-center text-3xl md:text-5xl font-extrabold mt-24 md:mt-36 text-[#0e4d38]">
                President’s Message
            </h2>

            {/* Top Section */}
            <div className="w-10/12 mx-auto flex flex-col md:flex-row items-center justify-between gap-12 mt-16">
                <img
                    src={President_img}
                    alt="President"
                    className="rounded-xl shadow-lg w-full md:w-1/3 object-cover"
                />
                <div className="space-y-4 md:w-2/3 text-center md:text-left border border-gray-300 rounded-lg p-6 shadow-md bg-white">
                    <h1 className="text-2xl md:text-3xl font-bold text-[#0e4d38]">
                        Mr. Manohar Lal Juyal
                    </h1>
                    <p className="text-md text-gray-600">President of Maya Dev University</p>
                    <blockquote className="italic text-lg text-[#0e4d38] bg-gray-100 p-4 rounded-lg shadow-sm border-l-4 border-[#0e4d38]">
                        "Think about every problem, every challenge, we face. The solution to each starts with education."
                    </blockquote>
                </div>

            </div>

            {/* Message Section */}
            <div className="w-10/12 mx-auto mt-16 flex flex-col-reverse md:flex-row items-center gap-12">
                <p className="text-justify text-gray-700 text-md leading-relaxed md:w-2/3">
                    <h6>
                        President's Message<br /><br />
                    </h6>
                    Maya Devi University is an outstanding Academics and Research
                    University. We take pride in our contributions to the betterment of
                    our Nation and the commitment of our faculty members to excellence in
                    teaching, creativity works, scholarship and research. We work to
                    foster our distinctive and helpful culture with commitment to the
                    values and culture, equity and inclusion. Since 2010 Maya Group has
                    changed in many important aspects and has built upon the best of our
                    founding ideals and ambitions. The result of more than a decade of
                    thoughtful progress has been the creation of one of the great
                    Universities of North India. Maya Devi University’s mission and
                    aspirations today are captured in our mission statement.<br />
                    <br />
                    Maya Devi University’s educational undertaking is significant,
                    involving approximately 11000+ Alumni of Graduate and Post Graduate
                    Students. The University has a tradition of providing practical
                    education that actively involves students in imaginative research,
                    promoting an exceptional form of “self-sufficient learning”.<br />
                    <br />
                    Students are encouraged to independently identify and address the
                    issues to promote a broad range of abilities and an inspired spirit
                    founded on strong scientific and philosophical knowledge. Creativity
                    is born from academic curiosity and inquisitiveness, and I hope that
                    the University’s tradition of “teaching through research with
                    cultural values” will foster a high degree of knowledge in our
                    students, and that they will become the next generation of creative
                    researchers or future entrepreneurs.<br/>

                    <span className="font-bold">
                        Manohar Lal Juyal<br />

                        President<br/>
                    </span>
                </p>
                <img
                    src={Img}
                    alt="Maya Devi University Logo"
                    className="rounded-xl shadow-lg w-full md:w-1/3 object-cover"
                />
            </div>

            {/* Footer */}
            <SubFooter />
         
            <Footer />
        </div>
    );
};

export default Presidents_msg;
